
import { required } from 'vuelidate/lib/validators'

export default {
  moving: {
    tower_id: {
      required
    },
    unit_id: {
      required
    },
    go_in_out: {
      required
    },
    type: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/moving/form/resources/validations.js